import React from 'react';

export default function Error() {
  return (
    <main className="team">
      <section>
        <div className="container">
          <div className="row">
            <div className="col">
              <h1 className="text-center mb-5">404: NGMI</h1>

              <div className="text-center">
                <p className="text-large mb-4">Let’s try something else</p>

                <a
                  href="https://discord.gg/duskbreakers"
                  target="_new"
                  id="discord-btn"
                  className="btn btn-outline-primary btn-lg"
                >
                  <svg
                    className="icon-discord"
                    aria-label="Discord Icon"
                    viewBox="0 0 500 360"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>Discord Icon</title>
                    <path
                      d="M430.7,39.9C387.4,6,319,0.3,316.1,0.1c-4.5-0.4-8.9,2.1-10.7,6.2c-0.2,0.2-1.7,3.6-3.3,8.8c28.6,4.7,63.8,14.2,95.6,33.4
              c5.1,3.1,6.7,9.6,3.5,14.6c-2.1,3.3-5.6,5-9.3,5c-2,0-3.9-0.5-5.7-1.6c-54.7-33-123-34.7-136.1-34.7c-13.2,0-81.5,1.7-136.1,34.7
              c-5.1,3.1-11.8,1.6-14.9-3.4c-3.2-5-1.6-11.5,3.5-14.6c31.8-19.2,67-28.7,95.6-33.4c-1.7-5.3-3.1-8.6-3.3-8.9
              c-1.9-4.1-6.2-6.7-10.8-6.2C181,0.3,112.6,6,68.7,40.4C45.8,61,0,181.6,0,285.9c0,1.9,0.5,3.6,1.4,5.3
              C33,345.2,119.3,359.4,138.9,360c0.1,0,0.2,0,0.3,0c3.5,0,6.8-1.6,8.8-4.3l19.9-26.6c-53.6-13.5-81-36.4-82.6-37.8
              c-4.5-3.8-4.9-10.5-0.9-14.9c3.9-4.4,10.8-4.8,15.3-1c0.6,0.6,51.1,42.3,150.3,42.3c99.4,0,149.8-41.9,150.3-42.3
              c4.5-3.8,11.3-3.4,15.3,1c3.9,4.4,3.5,11-1,14.9c-1.6,1.4-29,24.3-82.6,37.8l19.9,26.6c2,2.7,5.3,4.3,8.8,4.3c0.1,0,0.3,0,0.3,0
              c19.7-0.6,105.9-14.8,137.5-68.9c0.9-1.6,1.4-3.4,1.4-5.3C500,181.6,454.2,61,430.7,39.9z M179.3,243.5c-21,0-38-18.9-38-42.4
              s17-42.4,38-42.4s38,18.9,38,42.4S200.4,243.5,179.3,243.5z M320.7,243.5c-21,0-38-18.9-38-42.4s17-42.4,38-42.4
              c21,0,38,18.9,38,42.4S341.7,243.5,320.7,243.5z"
                    />
                  </svg>
                  <span className="ms-2">Discord</span>
                </a>

                <a
                  href="https://twitter.com/duskbreakers"
                  target="_new"
                  id="twitter-btn"
                  className="btn btn-outline-primary btn-lg ms-2 ms-lg-3"
                >
                  <svg
                    className="icon-twitter"
                    aria-label="Twitter Icon"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>Twitter Icon</title>
                    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                  </svg>
                  <span className="ms-2">Twitter</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
